import { render, staticRenderFns } from "./BasePostLogin.vue?vue&type=template&id=fafaf5be&scoped=true"
import script from "./BasePostLogin.vue?vue&type=script&lang=js"
export * from "./BasePostLogin.vue?vue&type=script&lang=js"
import style0 from "./BasePostLogin.vue?vue&type=style&index=0&id=fafaf5be&prod&lang=scss&scoped=true"
import style1 from "./BasePostLogin.vue?vue&type=style&index=1&id=fafaf5be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafaf5be",
  null
  
)

export default component.exports